import { React} from 'react';
import '../App.css'
// import Lottie from "lottie-react";
// import animationData from "../test2.json";
import videoFile from "../Comp 1_3.mp4";
import videoFile2 from "../Comp 3_2.mp4";

function Home() {
// const [scrollPosition, setScrollPosition] = useState(0);

// useEffect(() => {
//   const handleScroll = () => {
//     setScrollPosition(window.scrollY); // Update scroll position
//   };

//     window.addEventListener('scroll', handleScroll); // Listen to scroll event
//     return () => window.removeEventListener('scroll', handleScroll); // Cleanup
//   }, []);

//   const transformValue = `translateX(${scrollPosition /3}px)`; // Adjust the speed by changing the divisor
//   const transformValue2 = `translateX(-${scrollPosition /3}px)`; // Adjust the speed by changing the divisor
  
  return (
    <div className="home-title" id='home'>
      {/* <Lottie animationData={animationData} loop={true} />; */}
      <video className="video1" width="600" autoPlay muted playsInline preload="auto">
        <source src={videoFile} type="video/mp4" />
      </video>
      <video className="video2" width="600" autoPlay muted playsInline preload="auto">
        <source src={videoFile2} type="video/mp4" />
      </video>
      {/* <h1 className='title' style={{ transform: transformValue, transition: 'transform 0.1s ease' }}>Nikita George</h1>
      <p style={{ transform: transformValue2, transition: 'transform 0.1s ease' }}>Musican | Software Developer</p> */}
      {/* <video width="600" controls>
        <source src={Video} type="video/mp4" />
      </video> */}
    </div>
  );
}

export default Home;